export function capitalise(str: string) {
  const lower = str.toLowerCase()
  
  return str.charAt(0)?.toUpperCase() + lower?.slice(1)
}
